import { render, staticRenderFns } from "./fccInstrucoes.vue?vue&type=template&id=3db3caaa"
import script from "./fccInstrucoes.vue?vue&type=script&lang=js"
export * from "./fccInstrucoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports